export default class Accordion {
  constructor(accordionWrapperSelector) {
    this.accordionWrappers = document.querySelectorAll(
      accordionWrapperSelector
    );

    // Only proceed if there are accordion elements on the page
    if (!this.accordionWrappers.length) {
      return false;
    }

    // Initialize each accordion group
    this.accordionWrappers.forEach(wrapper => {
      // Select all buttons within the current accordion wrapper
      const accordionButtonElements = Array.from(
        wrapper.querySelectorAll("button[aria-expanded]")
      );

      // Entry methods
      this.addEventListeners(accordionButtonElements, wrapper);

      // check if hash matches a accordeon item
      const hash = window.location.hash;
      if (hash) {
        const container = wrapper.querySelector(hash);
        const button = container?.querySelector("button[aria-expanded]")
        if (button) {
          const controlsId = button.getAttribute("aria-controls");
          const content = wrapper.querySelector(`#${controlsId}`);

          this.closeAll(wrapper);
          this.toggle(button, content, true);

          setTimeout(() => {
            button.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 500);
        }
      }
    });
  }

  // Toggle visibility and update aria-expanded of content element
  toggle(button, content, open) {
    button.setAttribute("aria-expanded", `${open}`);
    if (open) {
      content.removeAttribute("hidden");
    } else {
      content.setAttribute("hidden", "");
    }
  }

  // Close all accordion items
  closeAll(wrapper) {
    const buttons = wrapper.querySelectorAll("button[aria-expanded='true']");
    buttons.forEach(button => {
      const controlsId = button.getAttribute("aria-controls");
      const content = wrapper.querySelector(`#${controlsId}`);
      this.toggle(button, content, false);
    });
  }

  // Handle button click events
  onButtonClick(event, wrapper) {
    const button = event.currentTarget;
    const controlsId = button.getAttribute("aria-controls");
    const content = wrapper.querySelector(`#${controlsId}`);
    const isOpen = button.getAttribute("aria-expanded") === "true";

    // Close all other accordion items
    this.closeAll(wrapper);

    // Toggle the clicked item
    this.toggle(button, content, !isOpen);
  }



  // Add click event listeners to each button in the accordion
  addEventListeners = (accordionButtonElements, wrapper) => {
    accordionButtonElements.forEach(button => {
      button.addEventListener("click", event => {
        this.onButtonClick(event, wrapper);
      });
    });
  };
}

document.addEventListener("DOMContentLoaded", () => {
  new Accordion(".egat-accordion");
});
